// Global cart watcher: auto-remove product addons that no longer have anything
// in the cart to attach to. Two independent rules, both driven by hidden line
// item properties written when the addon is added (assets/product-addon.js):
//
//   _requires_companion  -> remove when the addon is the last item in the cart
//   _shipping_only       -> remove when no shippable (non-addon) item remains
//
// This lives in its own site-wide script (loaded from layout/theme.liquid) so
// the check runs on EVERY page, not just product pages. The customer can add an
// item + addon on a product page, navigate elsewhere, then remove the main item
// from the cart drawer — the addon must still be cleaned up there.
document.addEventListener('DOMContentLoaded', () => {
  function isAddon(item) {
    return (item.properties || {})._is_addon === 'true';
  }

  // Keys of the addon lines that should no longer be in the cart.
  function findStrandedAddonKeys(cart) {
    const items = cart.items || [];
    const addons = items.filter(isAddon);
    if (addons.length === 0) return [];

    // An addon never counts as a companion for another addon.
    const hasShippableCompanion = items.some((item) => !isAddon(item) && item.requires_shipping === true);

    const keys = new Set();

    addons.forEach((addon) => {
      const props = addon.properties || {};

      // Sole item in the cart.
      if (props._requires_companion === 'true' && items.length === 1) {
        keys.add(addon.key);
      }

      // Nothing left that ships.
      if (props._shipping_only === 'true' && !hasShippableCompanion) {
        keys.add(addon.key);
      }
    });

    return Array.from(keys);
  }

  async function removeStrandedAddons() {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();

      const keys = findStrandedAddonKeys(cart);
      if (keys.length === 0) return;

      // One update call so multiple stranded addons are removed together —
      // line item keys stay valid, unlike positional indexes.
      const updates = {};
      keys.forEach((key) => {
        updates[key] = 0;
      });

      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContentsDrawer === 'function') {
        cartDrawer.renderContentsDrawer();
      } else if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'addon-cart-watcher' });
      }
    } catch (error) {
      console.error('Addon cart check failed:', error);
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
      // Ignore the event we publish ourselves to avoid a re-entrant loop.
      if (data && data.source === 'addon-cart-watcher') return;
      removeStrandedAddons();
    });
  }

  // Run once on load in case the cart already contains a stranded addon
  // (e.g. the customer removed the main item on a page without this listener,
  // or in an older tab, then loaded a fresh page).
  removeStrandedAddons();
});
